import { render, staticRenderFns } from "./MainNavBar.vue?vue&type=template&id=e5dce4c4&scoped=true"
import script from "./MainNavBar.vue?vue&type=script&lang=js"
export * from "./MainNavBar.vue?vue&type=script&lang=js"
import style0 from "./MainNavBar.vue?vue&type=style&index=0&id=e5dce4c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5dce4c4",
  null
  
)

export default component.exports